var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Hardware / keyboard arrow_right"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_8291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 8,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Round",
    d: "M9.00001 16.1393L12.88 12.2593L9.00001 8.37926C8.81275 8.19243 8.70752 7.93878 8.70752 7.67426C8.70752 7.40974 8.81275 7.15609 9.00001 6.96926C9.39001 6.57926 10.02 6.57926 10.41 6.96926L15 11.5593C15.39 11.9493 15.39 12.5793 15 12.9693L10.41 17.5593C10.02 17.9493 9.39001 17.9493 9.00001 17.5593C8.62001 17.1693 8.61001 16.5293 9.00001 16.1393Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_8291)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color Fill",
    y: 0.264648,
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRounded);
export default __webpack_public_path__ + "static/media/arrow_right_rounded.d6ef4b081c0dce8824639b9ac61b357f.svg";
export { ForwardRef as ReactComponent };